import React from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import BudgetPhase from 'routes/BudgetModule/components/shared/BudgetLibrary/BudgetPhase';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BudgetPhases } from 'business/constants';

const StyBudgetPhase = styled(BudgetPhase, {
    name: 'StyBudgetPhase',
})({
    padding: '0.2em 0.8em',
});

export default function PhaseCellRenderer({
    value,
}: CellRendererParams<unknown, BudgetPhases>): React.ReactElement | null {
    return value ? (
        <Box sx={{ lineHeight: 'initial' }}>
            <StyBudgetPhase phase={value} />
        </Box>
    ) : null;
}
